import { Grid, Stack } from '@mui/material';
import * as React from 'react';
import TitleGrid from './TitleGrid';
import _ from 'lodash';
import DailySeatTable from './DailySeatTable';
import { lerpColor } from '../utils';
import SeatChart from './SeatChart';

function jsonResultSize(json, isRisky) {
  if (json == null) {
    return '';
  }
  var dayRiskys = [];
  var dayDangerous = [];

  json.map((data, index) => {
    if (data.status === 2) {
      dayRiskys.push(data.seatNo);
    }
    if (data.value === 3) {
      dayDangerous.push(data.seatNo);
    }
  });
  return isRisky
    ? _.isEmpty(dayRiskys)
      ? '-'
      : dayRiskys.join(', ')
    : _.isEmpty(dayDangerous)
      ? '-'
      : dayDangerous.join(', ');
}

function setColor(score) {
  if (score >= 0 && score <= 50) {
    return '#ff0000';
  } else if (score > 50 && score <= 75) {
    return '#ff8000';
  } else if (score > 75 && score <= 90) {
    return '#ffd300';
  } else if (score > 90 && score <= 100) {
    return '#99bd89';
  } else {
    return '#d7e3f7';
  }
}

function calculateAverage(json) {
  if (json == null) {
    return '';
  }
  var size = 0;
  var totalScore = 0;
  var average = 0;
  json.map((data, index) => {
    if (data.status !== 0) {
      totalScore += data.score;
      size++;
    }
  });
  average = totalScore / size;
  average = average.toString();
  var array = average.split('');
  var result = '';
  for (var i = 0; i < array.length; i++) {
    result += array[i];
    if (array[i] === '.') {
      result += array[i + 1];
      break;
    }
  }
  if (result === 'NaN') {
    return '-';
  } else {
    return '% ' + result;
  }
}

const WeeklySeatScore = (props) => {
  const carJson = props.newData;
  const plate = props.plate;
  /*
  const day1MorningJson = props.day1MorningJson
  const day1EveningJson = props.day1EveningJson
  const day2MorningJson = props.day2MorningJson
  const day2EveningJson = props.day2EveningJson
  const day3MorningJson = props.day3MorningJson
  const day3EveningJson = props.day3EveningJson
  const day4MorningJson = props.day4MorningJson
  const day4EveningJson = props.day4EveningJson
  const day5MorningJson = props.day5MorningJson
  const day5EveningJson = props.day5EveningJson
  */

  return (
    <Grid
      container
      spacing={1}
      marginTop={1}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <div className=" page-content">
        <SeatChart
          title={`${plate} Riskli Koltuklar`}
          carJson={carJson}
          json={props.vehicleSafetyReport}
        />
      </div>
      <div>
        {carJson?.data?.map((item, index) => {
          return (
            <div key={index} className="page-content ">
              {index === 0 && (
                <div>
                  <TitleGrid
                    title={`${plate} Koltuk Güvenlik Skorları`}
                    widthRate="12"
                    padding="10px"
                    titleFontSize="h6"
                  />
                </div>
              )}
              <div className="flex flex-col m-2 gap-1 ">
                <TitleGrid
                  title={item?.name}
                  borderRadius="10px 10px 0px 0px"
                  backgroundColor="#506A8E"
                  textColor="white"
                  padding="3px"
                  titleFontSize="h8"
                />
                <div className="flex flex-row flex-wrap gap-3   ">
                  {item?.data?.map((item, index) => {
                    return (
                      <div key={index} className="flex flex-col">
                        <div
                          className={`flex flex-col  ${
                            item?.data?.length > 30
                              ? 'w-[378px]'
                              : item?.data?.length > 20 &&
                                  item?.data?.length <= 30
                                ? 'w-[183px]'
                                : 'w-[183px]'
                          }`}
                        >
                          <TitleGrid
                            title={item?.name}
                            padding="2px"
                            titleFontSize="h8"
                            textColor="white"
                            backgroundColor="#6989b5"
                          />
                          <DailySeatTable json={item?.data} />
                          <TitleGrid
                            title={calculateAverage(item?.data)}
                            textColor="black"
                            titleFontSize="h8"
                            padding="2px"
                            borderRadius="0px 0px 10px 10px"
                            widthRate={12}
                            backgroundColor={setColor(
                              calculateAverage(item?.data).split(' ')[1],
                            )}
                          />
                        </div>
                        {/* <div
                          className={`  ${item?.data?.length > 30
                            ? 'w-[378px]'
                            : item?.data?.length > 20 &&
                              item?.data?.length <= 30
                              ? 'w-[183px]'
                              : 'w-[183px]'
                            }`}
                        >
                          <TitleGrid
                            title={'Riskli Koltuk No'}
                            titleFontSize="h8"
                            textColor="color"
                            padding="2px"
                            backgroundColor="transparent"
                            backgroundColor="transparent"
                          />

                          <TitleGrid
                            title={jsonResultSize(item?.data, true)}
                            titleFontSize="h8"
                            backgroundColor="transparent"
                            backgroundColor="transparent"
                            padding="2px"
                            textColor="red"
                          />
                        </div> */}
                      </div>
                    );
                  })}
                  {item?.data?.length < 8 && (
                    <>
                      {[...Array(8 - item?.data?.length)].map((_, i) => {
                        // console.log(item?.data[0]?.data?.length);
                        return (
                          <div
                            key={i}
                            className={` flex justify-center items-center rounded-b-[10px] bg-[#f1f1f1]  ${
                              item?.data[0]?.data?.length > 30
                                ? 'w-[378px]'
                                : item?.data[0]?.data?.length > 20 &&
                                    item?.data[0]?.data?.length <= 30
                                  ? 'w-[183px]'
                                  : 'w-[183px]'
                            }`}
                          >
                            (N/A)
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/*  <DailySeatTable
                json={day1MorningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day1EveningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day2MorningJson}
                widthRate='1.2'
                />
            <DailySeatTable
                json={day2EveningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day3MorningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day3EveningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day4MorningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day4EveningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day5MorningJson}
                widthRate='1.2'
            />
            <DailySeatTable
                json={day5EveningJson}
                widthRate='1.2'
            /> */}

      {/* <div className=''>
        <div className='page-content'>
          <TitleGrid
            title={`${plate} Riskli Koltuk No - Risky Seat No`}
            widthRate='12'
            titleFontSize='h6'
          />
        </div>
        {carJson?.data?.map((item, index) => {
          return (
            <div key={index} className='flex flex-col page-content m-2 gap-1'>
              <TitleGrid
                title={item?.name}
                backgroundColor='#506A8E'
                padding='0 20px 0 20px'
                textColor='white'
                titleFontSize='h8'
              />
              <div className='flex flex-row flex-wrap gap-3'>
                {item?.data?.map((item, index) => {
                  return (
                    <div key={index} className='flex flex-col w-36'>
                      <TitleGrid
                        title={item?.name}
                        titleFontSize='h8'
                        textColor='white'
                        borderRadius='10px 10px 0px 0px'
                        backgroundColor='#6989b5'
                      />
                      <div style={{
                        display: 'grid',
                        placeItems: 'center',
                        height: '100%',
                        width: '100%',
                        backgroundColor: '#d7e3f7',
                        borderRadius: '0px 0px 10px 10px',
                      }}>
                        <TitleGrid
                          title={jsonResultSize(item?.data, true)}
                          titleFontSize='h8'
                          backgroundColor='#d7e3f7'
                          padding='5px'
                          textColor='red'
                        />
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div> */}

      {/*  <TitleGrid
                title={jsonResultSize(day1MorningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day1EveningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid title={jsonResultSize(day2MorningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid title={jsonResultSize(day2EveningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day3MorningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day3EveningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day4MorningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day4EveningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day5MorningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            />
            <TitleGrid
                title={jsonResultSize(day5EveningJson, true)}
                titleFontSize='h8'
                widthRate={1.2}
                backgroundColor='#d9d9d9'
                textColor='red'
            /> */}
    </Grid>
  );
};

export default WeeklySeatScore;
